import "./WorkflowsNavHeaderBotName.scss"
import { OrgInterface } from "@swivl-mono/types";
interface Props {
    org: OrgInterface
}
export function WorkflowsNavHeaderBotName({ org }: Props) {

    return <div className="WorkflowsNavHeaderBotName">
        <h1>{org.name}</h1>
        <Indicator org={org} />
    </div>
}

function Indicator({ org }: Props) {
    // const [showPopover, setShowPopover] = useState(true)

    if (org?.parentId) {
        return <div className={"Indicator isChild"} >Child
           {/* <DarkPopover top={23}>{org}</DarkPopover> */}
        </div>
    }
    if (org.isParent) { return <div className="Indicator">Parent </div> }
    return <div className="Indicator isStandalone">Standalone</div>
}